import { importLazy } from '../../../utils/import'

export const ChangePasswordDialog = importLazy(() => import('./ChangePassword/ChangePasswordDialog'))
export const ChangeLanguageDialog = importLazy(() => import('./ChangeLanguage/ChangeLanguageDialog'))
export const EditPhoneNumberDialog = importLazy(() => import('./EditPhoneNumber/EditPhoneNumber'))
export const EditOfficeNameDialog = importLazy(() => import('./EditOfficeName/EditOfficeName'))
export const UpdateBillingAddress = importLazy(() => import('./UpdateBillingAddress/UpdateBillingAddress'))
export const UpdateBillingEmail = importLazy(() => import('./UpdateBillingEmail/UpdateBillingEmail'))
export const UpdateTaxId = importLazy(() => import('./UpdateTaxId/UpdateTaxId'))
export const ReportDetail = importLazy(() => import('./ReportDetail/ReportDetail'))
export const ReportPurchaseDetail = importLazy(() => import('./ReportPurchaseDetail/ReportPurchaseDetail'))
export const InfoDialog = importLazy(() => import('./InfoDialog'))
export const PolicyContentDialog = importLazy(() => import('./PolicyContent'))
export const CompanyConsentDialog = importLazy(() => import('./CompanyDetailConsentDialog'))
export const AccountReportsAdvancedFilter = importLazy(() => import('./AccountReportsAdvancedFilter'))
export const PoliciesDialog = importLazy(() => import('./PoliciesDialog'))
export const ArchiveExportDialog = importLazy(() => import('./ArchiveExport/ArchiveExportDialog'))
export const NotificationDetailDialog = importLazy(() => import('./NotificationDetail/NotificationDetail'))
export const TransactionsDialog = importLazy(() => import('./Transactions/TransactionsDialog'))
export const InvitationLinkGenerationDialog = importLazy(
  () => import('./ProfileManagementInvitationLinkGeneration/ProfileManagementInvitationLinkGenerationDialog')
)
export const TransactionsAdvancedFilterDialog = importLazy(
  () => import('./TransactionsAdvancedFilter/TransactionsAdvancedFilter')
)
export const TransactionsExportDialog = importLazy(() => import('./TransactionsExportDialog/TransactionsExportDialog'))
export const ProfileManagementAdvancedFilterDialog = importLazy(
  () => import('./ProfileManagementAdvancedFilter/ProfileManagementAdvancedFilter')
)
export const ProfileManagementEditAccountDialog = importLazy(
  () => import('./ProfileManagementEditAccount/ProfileManagementEditAccount')
)
export const ProfileManagementDeleteAccountDialog = importLazy(
  () => import('./ProfileManagementDeleteAccount/ProfileManagementDeleteAccount')
)
export const ImportValidationExportDialog = importLazy(
  () => import('./ImportValidationExport/ImportValidationExportDialog')
)
export const ImportHistoryExportDialog = importLazy(() => import('./ImportHistoryExport/ImportHistoryExportDialog'))
export const ImportHistoryAdvancedFilter = importLazy(
  () => import('./ImportHistoryAdvancedFilter/ImportHistoryAdvancedFilter')
)
export const ImportSearchExportDialog = importLazy(() => import('./ImportSearchExport/ImportSearchExportDialog'))
export const CheckProductsConfirmDialog = importLazy(() => import('./CheckProductsConfirmDialog'))
export const ImportInvestigationDialog = importLazy(() => import('./ImportInvestigation/ImportInvestigation'))
export const InvoicesAdvancedFilterDialog = importLazy(() => import('./InvoicesAdvancedFilter/InvoicesAdvancedFilter'))
export const InvoiceDetailsDialog = importLazy(() => import('./InvoiceDetails/InvoiceDetailsDialog'))
export const UpdatePreferredProductDialog = importLazy(() => import('./UpdatePreferredProduct/UpdatePreferredProduct'))
export const ConfirmPreferredProductChangeDialog = importLazy(() => import('./ConfirmPreferredProductChange'))
